import { getInputKind } from './subfieldInputKind';
/**
 * The authority record type whose records may be offered as this subfield's
 * default value, or `null` when the subfield is not a single-value authority
 * picker.
 *
 * A picker with NO concrete `recordType` (the typeless fallback `getInputKind`
 * reports as `authority`) yields `null`: there is nothing to query, and a
 * picker over "all records" is not what the cataloguer will see either.
 */
export var authorityPickerTarget = function (subfield) {
    // A static enum wins over the picker reading — the renderer's
    // `StaticOptionsPicker` short-circuits on `selectOptions` before it ever looks
    // at `recordType`, so the editor must resolve in the same order or it would
    // offer records the form will never show.
    if (subfield.selectOptions && subfield.selectOptions.length > 0)
        return null;
    if (getInputKind(subfield) !== 'authority')
        return null;
    var target = subfield.recordType;
    if (!target || target.startsWith('VOCABULARY_'))
        return null;
    return target;
};
/**
 * True when the subfield's input is a static list of literals
 * (`selectOptions`), which the renderer shows as a closed `<Select>`. The list
 * IS the whole domain — unlike a vocabulary, nothing can be added at runtime —
 * so a default outside it can never be produced by the form.
 */
export var hasStaticOptions = function (subfield) {
    return Array.isArray(subfield.selectOptions) && subfield.selectOptions.length > 0;
};
